import React from 'react'
import { InjectedFormProps } from 'redux-form'
import Button from 'components/Button'
import { VpbxPlan } from '../VpbxPlan'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import { useGetUsagePlansQuery } from 'src/generated/graphql'
import LoadingDots from 'components/Loading/LoadingDots'
import { IPhoneSystemFormData } from '../PhoneSystemForm.container'

export interface ISelectPlanTypeProps {
  prev: () => void
  change: InjectedFormProps['change']
  formData: IPhoneSystemFormData
  setHeadings?: Function
}

export const SelectPlanType = (props: ISelectPlanTypeProps) => {
  const { formData, change, setHeadings } = props
  const { data } = useGetUsagePlansQuery()

  setHeadings &&
    setHeadings({
      heading: 'All In One in five!',
      subHeading: 'Just a few more minutes should do it!',
    })

  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        The first part of of your Vpbx application is your phone plan - either standard or
        unlimited. Every user will be on the same plan. After you've selected your plan, you'll need
        to pick your hardware.
      </div>
      {!data || !data.usagePlans ? (
        <LoadingDots />
      ) : (
        data.usagePlans
          .filter(plan => plan.productLine === 'Phone System')
          .map(plan => <VpbxPlan key={plan.id} plan={plan} change={change} />)
      )}
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" disabled={!formData.productName}>
          Next
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/SelectPlanType/SelectPlanType.tsx